import React from 'react'
import { Modal } from 'antd'
import styled from 'styled-components/macro'
import { CN_DOCUMENT_COPY } from 'src/utils/creditNoteDocumentHelpers'

/**
 * Chunk C1 — once-per-venue teaching for credit note documents.
 * “Got it” dismisses permanently; “Not now” closes without dismissing.
 */
const CreditNoteCoachModal = ({ visible, onGotIt, onNotNow }) => {
  return (
    <StyledModal
      title={CN_DOCUMENT_COPY.coachModalTitle}
      visible={visible}
      onOk={onGotIt}
      onCancel={onNotNow}
      okText='Got it'
      cancelText='Not now'
      destroyOnClose
    >
      <Lead>{CN_DOCUMENT_COPY.coachModalBody}</Lead>
      <Glossary>{CN_DOCUMENT_COPY.glossary}</Glossary>
      <Hint>{CN_DOCUMENT_COPY.emptyStateHelp}</Hint>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
`

const Lead = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
`

const Glossary = styled.p`
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  font-size: 13px;
  line-height: 1.45;
  color: #389e0d;
`

const Hint = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #595959;
`

export default CreditNoteCoachModal
